export const defaultModaisState = {
    financeiro: {
        solicitarAnaliseCredito: false,
        registrarRecebimento: false,
        atualizacaoCredito: false,
        incluirRecebimento: false,
        registrarPagamento: false,
        incluirPagamento: false,
        incluirLancamentoCCO: false,
        incluirLancamentoCaixaBanco: false,
        incluirCheque: false,
        apGlobal: false,
        adicionarCupom: false,
        gerarSimulacao: false,
    },
    cafe: {

    },
    comercial: {
        criarPedidoVenda: false,
    },
    estoque: {
        solicitarRessuprimento: false,
        listarCategorias: false,
        cadastrarProduto: false,
        solicitarCompraProduto: false,
        entradaProdutosregistrarRecebimento: false,
    },
    cadastros: {
        incluirCooperado: false
    },
    receituarioAgronomico:{
        incluirCultura: false,
        incluirPragas: false,
        incluirIngredientesAtivos: false,
        IncluirAgrotoxico: false,
        incluirPrescricoes: false,
    },
    fabrica: {

    },
}

export type Programas = "financeiro" | "cafe" | "comercial" | "estoque" | "cadastros" | "receituarioAgronomico" | 'fabrica' ;

export type ModaisStates = typeof defaultModaisState

export type ModaisKeys<T extends Programas> = keyof ModaisStates[T];